import type { ThemeProviderProps as MuiThemeProviderProps } from '@mui/material/styles';

import { useTranslate } from '@/locales';
import { themeConfigs } from '@/store/reducerSettings';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as ThemeVarsProvider } from '@mui/material/styles';
import { useSelector } from 'react-redux';

import type {} from './extend-theme-types';
import type { ThemeOptions } from './types';

import { createTheme } from './create-theme';
import { Rtl } from './with-settings/right-to-left';

// ----------------------------------------------------------------------

export type ThemeProviderProps = Partial<MuiThemeProviderProps> & {
  themeOverrides?: ThemeOptions;
};

export function ThemeProvider({ themeOverrides, children, ...other }: ThemeProviderProps) {
  // const { currentLang } = useTranslate();
  const themeConfiguration = useSelector(themeConfigs);

  const theme = createTheme({
    settingsState: themeConfiguration,
    // localeComponents: currentLang?.systemValue,
    themeOverrides,
  });

  return (
    <ThemeVarsProvider disableTransitionOnChange theme={theme} {...other}>
      <CssBaseline />
      <Rtl direction={themeConfiguration.direction}>{children}</Rtl>
    </ThemeVarsProvider>
  );
}
